import { ZoneEntity } from "@features/country/domain";
import { ZoneModel } from "../models/zone.model";

export function mapZone(zone: ZoneModel): ZoneEntity {
  return {
    id: zone.zoneId,
    name: zone.zoneName,
  };
}
